/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_AnalyticsInputs */

const en_admin_settings_tabs_analytics = /** @type {(inputs: Admin_Settings_Tabs_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Admin_Settings_Tabs_AnalyticsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_analytics = /** @type {((inputs?: Admin_Settings_Tabs_AnalyticsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_AnalyticsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_tabs_analytics(inputs)
});
export { admin_settings_tabs_analytics as "admin.settings.tabs.analytics" }